module.exports = __webpack_public_path__ + "img/ZAR10030.839bfbdd.png";